import * as React from 'react'

function SvgTl(props) {
	return (
		<svg viewBox="-3 -6 24 12" width="1em" height="1em" {...props}>
			<path d="M21 6V-6H-3V6z" fill="#dc241f" />
			<path d="M-3-6V6L9 0z" fill="#ffc726" />
			<path d="M-3-6V6l8-6z" />
			<g transform="rotate(-26.565)">
				<g id="tl_svg__c">
					<g id="tl_svg__b">
						<path
							d="M0-2.1V0h1z"
							fill="#fff"
							transform="rotate(18 0 -2.1)"
							id="tl_svg__a"
						/>
						<use xlinkHref="#tl_svg__a" transform="scale(-1 1)" />
					</g>
					<use xlinkHref="#tl_svg__b" transform="rotate(72)" />
				</g>
				<use xlinkHref="#tl_svg__b" transform="rotate(-72)" />
				<use xlinkHref="#tl_svg__c" transform="rotate(144)" />
			</g>
		</svg>
	)
}

export default SvgTl
